<template>
  <div class="bank-card-dialog">
    <custom-dialog :title="model.title" :appendToBody="true" :visible="visible" width="510px" v-on="$listeners">
      <div class="dialog-body">
        <!-- 表单 -->
        <el-form :model="bankCardForm" :rules="rules" :validate-on-rule-change="false" ref="bankCardForm">
          <el-form-item :label="$t('b_cards1_kai_hu_ming')" prop="depositName">
            <el-input v-model="bankCardForm.depositName" style="width: 460px"></el-input>
          </el-form-item>
          <el-form-item :label="$t('b_cards1_yhzh')" prop="depositNumber">
            <el-input v-model="bankCardForm.depositNumber" style="width: 460px"></el-input>
          </el-form-item>
          <el-form-item :label="$t('b_cards1_kai_hu_yin_hang')" prop="depositBank">
            <el-input v-model="bankCardForm.depositBank" style="width: 460px"></el-input>
          </el-form-item>
          <el-form-item :label="$t('b_cards1_zhlx')" prop="depositType">
            <custom-select v-model="bankCardForm.depositType" code="bank_deposit_type" :placeholder="$t('com_please_select')" style="width: 460px"></custom-select>
          </el-form-item>
          <el-form-item :label="$t('b_cards1_miao_shu')" prop="bankcardDesc">
            <el-input type="textarea" :rows="3" v-model="bankCardForm.bankcardDesc" style="width: 460px"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="visible = false">{{ $t('com_cancel') }}</el-button>
        <el-button type="warning" @click="addAddress">{{ $t('com_confirm') }}</el-button>
      </div>
    </custom-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

// b_cards1_kai_hu_ming: 开户名// b_cards1_yhzh: 银行账号// b_cards1_kai_hu_yin_hang: 开户银行// b_cards1_zhlx: 账户类型// b_cards1_miao_shu: 描述// b_cards1_qtxkhm: 请填写开户名// b_cards1_qtxyhzh: 请填写银行账号// b_cards1_qtxkhyh: 请填写开户银行// b_cards1_qxzzhlx: 请选择账户类型

export default {
  mixins: [dialogMixins],
  data() {
    return {
      bankCardForm: {
        // bankCode: '', // 开户行
        bankName: '', // 开户行名称
        depositName: '', // 账户名称
        depositNumber: '', // 账号
        depositBank: '', // 支行名称
        depositType: '', // 账号类型
        bankcardId: '',
        depositPurpose: [], // 账户类型(传空 不用了)
        bankcardDesc: '', // 账户用途
        partnerId: '', // 合作伙伴id(选传 传了就是合作伙伴  不传就是当前用户自己的银行信息)
        partnerOrgId: '',
      },
    };
  },
  computed: {
    rules() {
      return {
        depositName: [
          {
            required: true,
            message: this.$t('b_cards1_qtxkhm'),
          },
          { max: 50, message: ' ' },
        ], // 账户名称
        depositNumber: [
          {
            required: true,
            message: this.$t('b_cards1_qtxyhzh'),
          },
          { max: 30, message: ' ' },
        ], // 账号
        depositBank: [
          {
            required: true,
            message: this.$t('b_cards1_qtxkhyh'),
          },
          { max: 50, message: ' ' },
        ], // 支行名称
        depositType: [
          {
            required: true,
            message: this.$t('b_cards1_qxzzhlx'),
          },
        ],
      };
    },
  },
  mounted() {
    this.mergeLanguage(null, 'portal_bank_cards_dialog');
    this.initDialog();
  },
  methods: {
    // 初始化
    initDialog: function () {
      // 合作伙伴id(选传 传了就是合作伙伴  不传就是当前用户自己的银行信息)
      if (this.model.partnerOrgId) {
        // this.bankCardForm.partnerOrgId = this.model.partnerOrgId;
      } else {
        this.bankCardForm.partnerOrgId = this.$store.state.userInfo.rootOrgId;
      }
      if (this.model.type === 'edit') {
        this.$setFormatData(this.bankCardForm, this.model.data.item);
        // 后端返回的是数组字符串
        this.bankCardForm.depositPurpose = this.model.data.item.depositPurpose ? JSON.parse(this.model.data.item.depositPurpose) : [];
      }
    },
    onBankCode(item) {
      this.bankCardForm.bankName = item.bankName;
    },
    // 保存基本信息
    addAddress: function () {
      this.$refs.bankCardForm.validate((valid) => {
        if (!valid) {
          return;
        }
        if (this.model.type === 'edit') {
          this.$putJSON(apis.partnerBankcardUpdate, this.bankCardForm).then(() => {
            this.$message({
              message: this.$t('com_handle_success'),
              type: 'success',
            });
            this.visible = false;
            this.$emit('success');
          });
        } else if (this.model.partnerId) {
          //   // 合作伙伴
          //   this.$postJSON(apis.PartnerBankcardAddByOrgId, this.bankCardForm).then((res) => {
          //     this.$message({
          //       message: '操作成功',
          //       type: 'success'
          //     });
          //     this.visible = false;
          //     this.$emit('success');
          //   });
        } else {
          // 自己
          this.$postJSON(apis.partnerBankcardAdd, this.bankCardForm).then(() => {
            this.$message({
              message: this.$t('com_handle_success'),
              type: 'success',
            });
            this.visible = false;
            this.$emit('success');
          });
        }
      });
    },
  },
};
</script>

<style lang="scss">
.bank-card-dialog {
  .title {
    line-height: 24px;
    font-size: 16px;
    padding-left: 10px;
    position: relative;
    color: #595959;
    margin-bottom: 24px;
    .tag {
      width: 4px;
      height: 15px;
      background-color: #00afff;
      left: 0;
    }
  }
}
</style>
